import { observable, flow } from "mobx";
import { message } from "antd";
import {
  getTraineesData,
  getOtherSelectInfo,
  getSubject,
  addClass,
  queryClassList,
  queryClassDetail,
  queryClassDetailList,
  studentScore,
  deleteStudent,
  editClassStudentList,
} from "../../utils/api/createClass";

function handleResponse(response,callback,errorCallback){
  if(response.code===200){
    callback && callback(response)
  }else{
    message.error(response.msg || response.message || "请求失败，请重试")
    if(errorCallback){
      errorCallback(response)
    }else{
      // callback && callback({})
    }
    
  }
}


class CreateClass {
  @observable loading = false;
  getStudentData = flow(function* ({ callback, ...params }) {
    this.loading = true;
    yield getTraineesData(params).then(
      (res) => {
        this.loading = false;
        handleResponse(res.data,callback)
      },
      (error) => {
        this.loading = false;
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
  getSubjetNameAssociationInfo = flow(function* ({ callback, id }) {
    //获取课程名称相关联的其他信息
    yield getOtherSelectInfo(id).then(
      (res) => {
        handleResponse(res.data,callback)
      },
      (error) => {
        handleResponse(error.response.data,callback)
      }
    );
  });
  getSubject = flow(function* ({ callback }) {
    yield getSubject().then((res) => {
      handleResponse(res.data,callback)
    },(error)=>{
      handleResponse(error.response.data,callback)
    });
  });
  addClass = flow(function* ({ callback, params }) {
    this.loading = true;
    yield addClass(params).then(
      (res) => {
        this.loading = false;
        handleResponse(res.data,()=>{
          callback && callback(res.data);
          message.success(params.hasOwnProperty("id")?"班级编辑程功":"班级创建成功");
          window.history.back();
        })
      },
      (error) => {
        this.loading = false;
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
  queryClassList = flow(function* ({ callback, params }) {
    this.loading = true;
    yield queryClassList(params).then((res)=>{
      this.loading = false
      handleResponse(res.data,callback)
    },(error)=>{
      this.loading = false
      handleResponse(error.response.data,callback)
    })
    
  }).bind(this);
  queryClassDetail = flow(function* ({ callback, id }) {
    yield queryClassDetail(id).then(
      (res) => {
        handleResponse(res.data,callback)
      },
      (error) => {
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
  queryClassDetailList = flow(function* ({ callback, params }) {
    yield queryClassDetailList(params).then(
      (res) => {
        handleResponse(res.data,callback)
      },
      (error) => {
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
  studentScore = flow(function* ({ callback, params }) {
    yield studentScore(params).then(
      (res) => {
        handleResponse(res.data,()=>{
          callback && callback(res.data);
          message.success("评价成功");
        })
      },
      (error) => {
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
  deleteStudent = flow(function* ({ callback, params }) {
    this.loading = true;
    yield deleteStudent(params).then(
      (res) => {
        this.loading = false;
        handleResponse(res.data,()=>{
          callback && callback(res.data);
          message.success("删除成功");
        })
      },
      (error) => {
        this.loading = false;
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
  editClassStudentList = flow(function* ({ callback, params }) {
    this.loading = true;
    yield editClassStudentList(params).then(
      (res) => {
        this.loading = false;
        handleResponse(res.data,callback)
      },
      (error) => {
        this.loading = false;
        handleResponse(error.response.data,callback)
      }
    );
  }).bind(this);
}
export default CreateClass;
